export const steps = [
  {
    title: "Explore the Meals",
    description:
      "Browse a curated selection of delicious, chef-prepared, home-style dishes—updated every week to bring variety and freshness to your dining experience.",
    image: "https://i.ibb.co/wF3LJGZZ/explore-food.webp",
  },
  {
    title: "Create Your Meal Plan",
    description:
      "Easily customize your weekly meal plan by picking your favorites. Choose the quantity, adjust for dietary needs, and set your schedule—all in just a few clicks.",
    image: "https://i.ibb.co/qMYWBfgF/create-plan.webp",
  },
  {
    title: "Place Your Order",
    description:
      "Review your personalized meal plan, make final adjustments, and place your order with a smooth and secure checkout process tailored for your convenience.",
    image: "https://i.ibb.co/DPfs2MrN/place-order.webp",
  },
  {
    title: "Provider Will Cook",
    description:
      "Our trusted providers begin preparing your meals with the freshest ingredients, cooked with care to match the quality and comfort of a home-cooked dish.",
    image: "https://i.ibb.co/TqdQ7gGm/cooking.webp",
  },
  {
    title: "Delivery To Your Door Step",
    description:
      "Once ready, your meals are safely packaged and delivered straight to your doorstep—fresh, on time, and ready to enjoy at your convenience.",
    image: "https://i.ibb.co/HDyzZsMX/meal-delivery.webp",
  },
  {
    title: "Then Enjoy Your Meal",
    description:
      "Simply heat and eat. No prep, no cleanup—just wholesome, satisfying meals that bring the taste of home to your table, anytime you want.",
    image: "https://i.ibb.co/Kcq8WPK9/enjoy-meal.webp",
  },
];
